'use strict';
import $ = require('jquery');
import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(DrawSVGPlugin);

export class recruitGsap {
    constructor() {
        if ($('.bulletRecruitGsap').length === 0) return;

        const targets = document.querySelectorAll('.bulletRecruitGsap path');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    gsap.to(entry.target, {
                        drawSVG: "100%",
                        duration: 2,
                        ease: "power1.inOut",
                        force3D: true,
                        lazy: false
                    });
                }else{
                    gsap.to(entry.target, { drawSVG: "0%", duration: 0 });
                }
            });
        }, {
            root: null,
            threshold: 0,
            rootMargin: '-50% 0px',
        });

        targets.forEach(target => {
            observer.observe(target);
        });
    }
}

export default recruitGsap;